import { useSyncExternalStore } from 'react';

const IMPERSONATE_USER_KEY = 'impersonateUser';
const IMPERSONATE_ACCOUNT_KEY = 'impersonateAccount';

function getImpersonationSnapshot() {
  const userString = window.localStorage.getItem(IMPERSONATE_USER_KEY) || '';
  const accountString = window.localStorage.getItem(IMPERSONATE_ACCOUNT_KEY) || '';
  return `${userString}|||${accountString}`;
}

function subscribe(callback) {
  function handler(e) {
    if (
      e.key === IMPERSONATE_USER_KEY ||
      e.key === IMPERSONATE_ACCOUNT_KEY
    ) {
      callback();
    }
  }
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}

export function useImpersonationStore() {
  const snapshot = useSyncExternalStore(
    subscribe,
    getImpersonationSnapshot
  );
  const [userString, accountString] = snapshot.split('|||');
  let user = null;
  if (userString) {
    try {
      user = JSON.parse(userString);
    } catch {
      user = null;
    }
  }
  const account = accountString || null;
  return { user, account };
}
